<ng-container *cftI18n="let t">
  <div class="flex justify-between">
    <div class="flex items-center text-xs md:text-sm">
      <div class="h-3 w-3 rounded-full bg-purple-800"></div>
      <div class="ml-sm">{{ t('priceBreakdown.craftsManServiceCost') }}</div>
    </div>
    @if (breakdown.serviceCosts) {
      <div class="flex items-center rounded-1 bg-purple-800 px-xs text-xs text-white">
        {{ breakdown.serviceCosts }} %
      </div>
    } @else {
      <div class="flex items-center rounded-1 bg-grey-200 px-xs text-xs text-grey-500 md:text-sm">
        {{ t('priceBreakdown.notSpecified') }}
      </div>
    }
  </div>

  <div class="mt-sm flex justify-between">
    <div class="flex items-center text-xs md:text-sm">
      <div class="h-3 w-3 rounded-full bg-purple-500"></div>
      <div class="ml-sm">{{ t('priceBreakdown.fee') }}</div>
    </div>
    @if (breakdown.buildigoFee) {
      <div class="flex items-center rounded-1 bg-purple-500 px-xs text-xs text-white">
        {{ breakdown.buildigoFee }} %
      </div>
    } @else {
      <div class="flex items-center rounded-1 bg-grey-200 px-xs text-xs text-grey-500 md:text-sm">
        {{ t('priceBreakdown.notSpecified') }}
      </div>
    }
  </div>

  @if (breakdown.materialCost) {
    <div class="mt-sm flex justify-between">
      <div class="flex items-center text-sm">
        <div class="h-3 w-3 rounded-full bg-purple-300"></div>
        <div class="ml-sm">{{ t('priceBreakdown.materialCost') }}</div>
      </div>
      <div class="flex items-center rounded-1 bg-purple-300 px-xs text-xs text-white">
        {{ breakdown.materialCost }} %
      </div>
    </div>
  }

  @if (breakdown.additionalCost) {
    <div class="mt-sm flex justify-between">
      <div class="flex items-center text-sm">
        <div class="h-3 w-3 rounded-full bg-purple-300"></div>
        <div class="ml-sm">{{ t('priceBreakdown.additionalCost') }}</div>
      </div>
      <div class="flex items-center rounded-1 bg-purple-300 px-xs text-xs text-white">
        {{ breakdown.additionalCost }} %
      </div>
    </div>
  }
</ng-container>
